import PropTypes from "prop-types"
import CardPaymentForm from "./CardPaymentForm"
import { Modal } from "ui/Modal"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import CustomDrawer from "ui/Drawer"
import StripeWrapper from "components/stripe/StripeWrapper"
import { useState } from "react"
import { UnsavedChangesModal } from "ui/UnsavedChangesModal"

const CollectPaymentModal = ({ onOpen, onClose, remainingBalance, bookingUUID, bookingId }) => {
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)

  const requestClose = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedModal(true)
      return
    }
    executeClose()
  }

  const executeClose = () => {
    setShowUnsavedModal(false)
    onClose()
  }

  const modalContent = (
    <StripeWrapper>
      <CardPaymentForm onClose={requestClose} bookingId={bookingId} bookingUUID={bookingUUID} remainingBalance={remainingBalance} onUnsavedChangesChange={setHasUnsavedChanges} />
    </StripeWrapper>
  )

  return (
    <>
      {isMobile ? (
        <CustomDrawer open={onOpen} setOpen={requestClose} title="Collect Payment">
          {modalContent}
        </CustomDrawer>
      ) : (
        <Modal centered title="Collect Payment" open={onOpen} onCancel={requestClose} width={800}>
          {modalContent}
        </Modal>
      )}
      <UnsavedChangesModal
        open={showUnsavedModal}
        onDiscard={executeClose}
        onKeepEditing={() => setShowUnsavedModal(false)}
        zIndex={1200}
      />
    </>
  )
}

CollectPaymentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  remainingBalance: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number
}

export default CollectPaymentModal
